'use strict';

var Consts = require('consts');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var Validation = require('utils/validation');

var checkCSVSeries = function (s) {
    var cnt = {};
    var valid = true;

    _.each(s.fields, function (fld, idx) {
        var mode = fld.mode;
        cnt[mode] = (cnt[mode] || 0) + 1;
        if (mode == 0) return;
        if (idx > 0) {
            valid = false;
            return;
        }
        if (mode != 3) {
            valid = false;
            return;
        }
    });
    return !valid || (cnt[3] && cnt[0]);
};

var DeviceReportDialogView = OOP.extend(
    Marionette.ItemView,
    {
        template: require('components/profile/templates/device_report_dialog'),
        fieldValuesEnum: {},

        initialize: function (options) {
            this.base.initialize(options);
            this.cb = options.cb;

            this.data = {
                name: options.model.get('name'),
                description: options.model.get('description'),
                is_active: options.model.get('is_active'),
                hide_title_page: options.model.get('hide_title_page'),
                hide_description: options.model.get('hide_description'),
                period: options.model.get('period'),
                format: options.model.get('format'),
                receiver_list: options.model.get('receiver_list'),
            };
        },

        ui: {
            edtName: '#report-name',
            edtDescription: '#report-description',
            chkIsActive: '#is-active',
            ddlReportPeriod: 'select.js-report-period',
            ddlReportFormat: 'select.js-report-format',
            ddlMailingList: 'select#js-mailing-list',
            chkHideTitlePage: '#hide-title-page',
            chkHideDescription: '#hide-description',
        },

        events: OOP.inheritedObj('events', {
            'click .js-report-attr': function (e) {
                this.saveReportData(e.target, false);
            },
            'change .js-report-attr': function (e) {
                this.saveReportData(e.target, false);
            },
            'keyup .js-report-attr': function (e) {
                this.saveReportData(e.target, false);
            },
            'click .js-report-attr-redraw': function (e) {
                this.saveReportData(e.target, true);
            },
            'change select.js-report-attr-redraw-select': function (e) {
                this.saveReportData(e.target, true);
            },
            'click #js-success': function (e) {
                this.submit();
            },
        }),

        serializeData: function () {
            var model = this.options.model;
            var data = this.base.serializeData();

            data.errors = this.errors;
            data.mailboxes = this.options.mailboxes ? this.options.mailboxes.toJSON() : [];
            data.report = this.data;
            data.periods = Consts.ReportPeriods;
            data.formats = Misc.selectWhere(Consts.ReportFormats, undefined, function (item) {
                var content = model.get('content');
                return {
                    value: item.value,
                    text: item.text,
                    icon: item.icon,
                    disabled: item.value == 1 && content && (content.length > 1 || checkCSVSeries(content[0])),
                };
            });

            return data;
        },

        saveReportData: function (tgt, doRedraw) {
            this.data.name = this.ui.edtName.val();
            this.data.description = this.ui.edtDescription.val();
            this.data.is_active = this.ui.chkIsActive.prop('checked');
            this.data.period = parseInt(this.ui.ddlReportPeriod.val());
            this.data.format = parseInt(this.ui.ddlReportFormat.val());
            this.data.receiver_list = this.ui.ddlMailingList.val();
            this.data.hide_title_page = this.ui.chkHideTitlePage.prop('checked');
            this.data.hide_description = this.ui.chkHideDescription.prop('checked');

            if (doRedraw) {
                this.render();
            }
        },

        submit: function () {
            var self = this;
            var isValid = Validation.validate(
                this,
                function (frm) {
                    this.required('name', frm.data.name, I18N.TR('Der Name muss angegeben werden.'), frm.ui.edtName);
                    this.maxLen(
                        'name',
                        frm.data.name,
                        100,
                        I18N.TR('Der Name darf nicht länger als 100 Zeichen sein.'),
                        frm.ui.edtName
                    );
                    this.maxLen(
                        'description',
                        frm.data.description,
                        4000,
                        I18N.TR('Die Beschreibung darf nicht länger als 4000 Zeichen sein.'),
                        frm.ui.edtDescription
                    );
                },
                undefined,
                true
            );

            if (isValid && this.cb) {
                // move data to the model
                _.each(
                    ['name', 'description', 'format', 'period', 'is_active', 'hide_title_page', 'hide_description'],
                    function (key) {
                        self.options.model.set(key, self.data[key]);
                    }
                );
                this.options.model.set(
                    'receiver_list',
                    _.map(this.data.receiver_list, function (x) {
                        return parseInt(x);
                    })
                );
                this.options.model.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
                this.cb(this.options.model);
            }
        },

        onShow: function () {
            Misc.initSelectPicker();
        },

        onRender: function () {
            Misc.initSelectPicker();
        },
    },
    'DeviceReportDialogView'
);

module.exports = DeviceReportDialogView;
